"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "day-report"
  }, [_c("div", {
    staticClass: "calendar"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "day-header"
  }, [_c("div", {
    staticClass: "date",
    staticStyle: {
      width: "30%"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      height: "25px"
    },
    attrs: {
      "value-format": "yyyy-MM",
      clearable: false,
      "picker-options": _vm.pickerOptions1,
      type: "month",
      placeholder: "select"
    },
    model: {
      value: _vm.nowMonth,
      callback: function callback($$v) {
        _vm.nowMonth = $$v;
      },
      expression: "nowMonth"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "date",
    staticStyle: {
      "padding-left": "250px"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "year",
      placeholder: "select",
      clearable: false,
      "value-format": "yyyy",
      format: "yyyy",
      "picker-options": _vm.pickerOptions0
    },
    on: {
      change: _vm.handleTime
    },
    model: {
      value: _vm.monthData,
      callback: function callback($$v) {
        _vm.monthData = $$v;
      },
      expression: "monthData"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "date dateSel",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: "",
      "collapse-tags": ""
    },
    model: {
      value: _vm.calendarData,
      callback: function callback($$v) {
        _vm.calendarData = $$v;
      },
      expression: "calendarData"
    }
  }, _vm._l(_vm.haveData, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key,
        hegiht: "28px"
      }
    });
  }), 1)], 1), _vm._v(" "), _vm.$isBtnAuth("report:batchDown") && _vm.userInfo.reportDownload == 0 ? _c("el-button", {
    staticClass: "download-box",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      plain: "",
      size: "small"
    },
    on: {
      click: _vm.handleBatchDown
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("all.pldc")) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c("section", {
    staticClass: "left-main"
  }, [_c("div", {
    staticClass: "left-item"
  }, [_c("div", {
    staticClass: "line-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("report.nhgl")))])]), _vm._v(" "), _c("div", {
    staticClass: "line-chart"
  }, [_c("div", {
    style: "position: absolute;width: 100%;height: 100%;zoom:".concat(_vm.zoomrAtio, ";transform:scale(").concat(_vm.zoom, ");transform-origin:0px 0px;"),
    attrs: {
      id: "first"
    }
  })]), _vm._v(" "), _c("el-button", {
    staticClass: "look",
    attrs: {
      plain: "",
      size: "mini",
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.initChart(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("all.yl")))])], 1), _vm._v(" "), _c("div", {
    staticClass: "left-item"
  }, [_c("div", {
    staticClass: "line-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("report.nhzb")))])]), _vm._v(" "), _c("div", {
    staticClass: "line-chart"
  }, [_c("div", {
    style: "position: absolute;width: 100%;height: 100%;zoom:".concat(_vm.zoomrAtio, ";transform:scale(").concat(_vm.zoom, ");transform-origin:0px 0px;"),
    attrs: {
      id: "second"
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "left-item"
  }, [_c("div", {
    staticClass: "line-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("report.sjtj")))])]), _vm._v(" "), _c("div", {
    staticClass: "line-chart"
  }, [_c("div", {
    style: "position: absolute;width: 100%;height: 100%;zoom:".concat(_vm.zoomrAtio, ";transform:scale(").concat(_vm.zoom, ");transform-origin:0px 0px;"),
    attrs: {
      id: "line"
    }
  })]), _vm._v(" "), _c("el-button", {
    staticClass: "look",
    attrs: {
      plain: "",
      size: "mini",
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.initChart(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("all.yl")))])], 1), _vm._v(" "), _c("div", {
    staticClass: "left-item"
  }, [_c("div", {
    staticClass: "line-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("report.nxgl")))])]), _vm._v(" "), _c("div", {
    staticClass: "line-chart"
  }, [_c("div", {
    style: "position: absolute;width: 100%;height: 100%;zoom:".concat(_vm.zoomrAtio, ";transform:scale(").concat(_vm.zoom, ");transform-origin:0px 0px;"),
    attrs: {
      id: "fourth"
    }
  })]), _vm._v(" "), _c("el-button", {
    staticClass: "look",
    attrs: {
      plain: "",
      size: "mini",
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.initChart(4);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("all.yl")))])], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticClass: "day-header day-left",
    staticStyle: {
      width: "100%",
      "justify-content": "space-between"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("el-button", {
    staticClass: "checkAll",
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.handlePreview
    }
  }, [_vm._v(_vm._s(_vm.$t("all.yl")))]), _vm._v(" "), _vm.$isBtnAuth("report:down") && _vm.userInfo.reportDownload == 0 ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "download-box",
    attrs: {
      plain: "",
      size: "small",
      disabled: _vm.isCurrentMonth
    },
    on: {
      click: _vm.handlOneDown
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("all.dc")) + "\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c("div", {
    staticClass: "ifrma-box"
  }, [_c("div", {
    staticClass: "img-box"
  }), _vm._v(" "), _c("div", {
    staticClass: "main-box"
  }, [_c("div", {
    staticClass: "title-box"
  }, [_vm._v(_vm._s(_vm.$t("nb.title")))]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.energy_efficiency")) + "\n            "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.monthAverageCop))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.copMonthDifference))])]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.cooling_price")) + "\n            "), _c("el-popover", {
    attrs: {
      placement: "bottom-start",
      title: "",
      width: "300",
      trigger: "click",
      content: ""
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("nb.cooling_price_tip")))]), _vm._v(" "), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("i", {
    staticClass: "el-icon-info",
    staticStyle: {
      color: "#39b149"
    }
  })])]), _vm._v(" "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.monthAverageColdPrice))]), _vm._v("\n            RM/kWh,\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.coldPriceMonthDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "RM/kWh") + "\n          ")], 1), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.cooling_quantity")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthCoolingCapacity))]), _vm._v("\n            kWh,\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.coolingCapacityMonthDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "kWh") + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.power_consumption")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthPowerConsumption))]), _vm._v("\n            kWh,\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.powerConsumptionMonthDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "kWh") + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.estimated_cost")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthEstimatedTariff))]), _vm._v("\n            RM,\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.estimatedTariffMonthDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "RM") + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.total_cooling_duration")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthTotalSupplyTime))]), _vm._v("\n            H\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.monthTotalSupplyTimeDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "H") + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.daily_cooling_duration")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.dailyAverageSupplyTime))]), _vm._v("\n            H\n            " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.dailyAverageSupplyTimeDifference))]), _vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? "" : "H") + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(this.nowMonth) + " " + _vm._s(_vm.$t("nb.wet_bulb_temperature")) + "\n            "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.wetBulbTemperature))])]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.isCurrentMonth ? _vm.$t("nb.as_of_yesterday") : _vm.$t("nb.as_of_end_of_month")) + ",\n            " + _vm._s(_vm.$t("nb.year_to_date_efficiency")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.yearCop))]), _vm._v(",\n            " + _vm._s(_vm.$t("nb.cooling_price")) + "\n            "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.yearColdPrice))]), _vm._v("\n            RM/kWh,\n\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("nb.encouragement")) + "\n          ")])]), _vm._v(" "), _c("div", {
    staticClass: "remark"
  })])]), _vm._v(" "), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible,
      width: "30%",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "dialog-heard"
  }, [_vm.$isBtnAuth("report:down") && _vm.userInfo.reportDownload == 0 ? _c("el-button", {
    staticClass: "download-box",
    attrs: {
      plain: "",
      size: "small",
      disabled: _vm.isCurrentMonth
    },
    on: {
      click: _vm.handlOneDown
    }
  }, [_vm._v(_vm._s(_vm.$t("all.xz")))]) : _vm._e(), _vm._v(" "), _c("span", {
    staticStyle: {
      position: "absolute",
      top: "15px",
      right: "30px",
      "font-weight": "bold",
      color: "red",
      "font-size": "20px",
      cursor: "pointer"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("\n          X\n        ")])], 1), _vm._v(" "), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.show,
      expression: "show"
    }]
  }, [_c("div", {
    staticClass: "ifrma-box active-box"
  }, [_vm.reportLogoVisible == 2 ? _c("div", {
    staticClass: "img-box"
  }) : _vm._e(), _vm._v(" "), _vm.reportLogoVisible == 1 ? _c("div", {
    staticClass: "logoimg-box"
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "main-box"
  }, [_c("div", {
    staticClass: "title-box"
  }, [_vm._v(_vm._s(_vm.$t("nb.title")))]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.energy_efficiency")) + "\n              "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.monthAverageCop))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.copMonthDifference))])]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.cooling_price")) + "\n              "), _c("el-popover", {
    attrs: {
      placement: "bottom-start",
      title: "",
      width: "300",
      trigger: "click",
      content: ""
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("nb.cooling_price_tip")))]), _vm._v(" "), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("i", {
    staticClass: "el-icon-info",
    staticStyle: {
      color: "#39b149"
    }
  })])]), _vm._v(" "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.monthAverageColdPrice))]), _vm._v("\n              RM/kWh,\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.coldPriceMonthDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "RM/kWh") + "\n            ")], 1), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.cooling_quantity")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthCoolingCapacity))]), _vm._v("\n              kWh,\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.coolingCapacityMonthDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "kWh") + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.power_consumption")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthPowerConsumption))]), _vm._v("\n              kWh,\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.powerConsumptionMonthDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "kWh") + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.estimated_cost")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthEstimatedTariff))]), _vm._v("\n              RM,\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.estimatedTariffMonthDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "RM") + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.total_cooling_duration")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.monthTotalSupplyTime))]), _vm._v("\n              H\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.monthTotalSupplyTimeDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "H") + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("nb.daily_cooling_duration")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.dailyAverageSupplyTime))]), _vm._v("\n              H\n              " + _vm._s(_vm.isCurrentMonth ? "" : _vm.$t("nb.compare_last_month")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.isCurrentMonth ? "" : _vm.previewData.dailyAverageSupplyTimeDifference))]), _vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? "" : "H") + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(this.nowMonth) + " " + _vm._s(_vm.$t("nb.wet_bulb_temperature")) + "\n              "), _c("span", {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.previewData.wetBulbTemperature))])]), _vm._v(" "), _c("div", {
    staticClass: "date-box"
  }, [_vm._v("\n              " + _vm._s(_vm.isCurrentMonth ? _vm.$t("nb.as_of_yesterday") : _vm.$t("nb.as_of_end_of_month")) + ",\n              " + _vm._s(_vm.$t("nb.year_to_date_efficiency")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.yearCop))]), _vm._v(",\n              " + _vm._s(_vm.$t("nb.cooling_price")) + "\n              "), _c("span", {
    staticClass: "numbox"
  }, [_vm._v(_vm._s(_vm.previewData.yearColdPrice))]), _vm._v("\n              RM/kWh,\n              " + _vm._s(_vm.$t("nb.encouragement")) + "\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "table-box",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "94%"
    },
    attrs: {
      data: _vm.previewData.monthProjectExcelDTOList,
      border: "",
      "header-cell-style": {
        background: "#eeeeee",
        color: "#333333",
        fontSize: "14px"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "time",
      label: _vm.$t("nbyl.date"),
      width: "100",
      formatter: _vm.formatterTime
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "host",
      label: _vm.$t("nbyl.host_power_consumption")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "ldb",
      label: _vm.$t("nbyl.freezer_pump_power_consumption")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "lqb",
      label: _vm.$t("nbyl.cooling_pump_power_consumption")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "lqt",
      label: _vm.$t("nbyl.cooling_tower_power_consumption")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "dl",
      label: _vm.$t("nbyl.total_power_consumption")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "gll",
      label: _vm.$t("nbyl.total_cooling_capacity")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "df",
      label: _vm.$t("nbyl.electricity_fee")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "cop",
      label: _vm.$t("nbyl.comprehensive_efficiency")
    }
  })], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "remark"
  })])])])], 1), _vm._v(" "), _c("div", {
    staticStyle: {
      position: "absolute",
      left: "0px",
      top: "0px",
      background: "rgba(0, 0, 0, 0.4)",
      width: "100%",
      height: "100%",
      filter: "alpha(opacity=60)",
      display: "none",
      "z-index": "1"
    },
    attrs: {
      id: "magnifyChart1"
    }
  }, [_c("div", {
    staticStyle: {
      position: "relative",
      width: "66%",
      height: "66%",
      margin: "8% auto",
      "z-index": "2",
      "background-color": "rgb(255, 255, 255)",
      "-webkit-tap-highlight-color": "transparent",
      "user-select": "none"
    }
  }, [_c("span", {
    staticClass: "close",
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("X")]), _vm._v(" "), _c("div", {
    style: "width: 100%;height: 100%;",
    attrs: {
      id: "magnifyChartData"
    }
  })])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;